export default "__VITE_ASSET__82c6f5da__"